import { lazy, Suspense } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/shared/contexts/AuthProvider";
import { ToastProvider } from "@/shared/contexts/ToastContext";
import { ThemeProvider } from "@/shared/contexts/ThemeProvider";
import ToastContainer from "@/shared/components/ui/ToastContainer";
import { PermissionDevPanel } from "@/app/components/PermissionDevPanel";
import { PERMISSION_PANEL_ENABLED } from "@/features/auth/access-config";
import { queryClient } from "@/shared/lib";

const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then((module) => ({
        default: module.ReactQueryDevtools,
      })),
    )
  : null;

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            {children}
            {PERMISSION_PANEL_ENABLED ? <PermissionDevPanel /> : null}
            {ReactQueryDevtools ? (
              <Suspense fallback={null}>
                <ReactQueryDevtools initialIsOpen={false} />
              </Suspense>
            ) : null}
            <ToastContainer />
          </QueryClientProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
};
